// Call function after element re render
// Usage
// v-e-element-rerender="() => updateSummary(item)"
// or
// v-e-element-rerender="updateSummary(item)"

export default {
  inserted: (el, binding) => execExpression(binding),
  update: (el, binding) => execExpression(binding)
}

function execExpression (binding) {
  let {value} = binding
  if (typeof value === 'function') {
    value()
  }
}
